import { TOGGLE_ESTIMATOR } from './mutations';

const actions = {
  [TOGGLE_ESTIMATOR]({ commit }) {
    commit({ type: TOGGLE_ESTIMATOR, payload: '' });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/estimator/actions.js